<script setup lang="ts">
import CmsCustomComponent from '~/layers/cms/app/components/cms/CmsCustomComponent.vue'
import type { CmsCustomComponentType } from '~/layers/cms/app/types/cmsTypes'

const props = defineProps<{
  cmsDataPath: (string | number)[]
}>()

const nazwa_komponentu = 'Oddzielniki/H60'

const component_default_values: CmsCustomComponentType = {}
</script>

<template>
  <CmsCustomComponent
    :cms-data-path="[...props.cmsDataPath]"
    :defaults="component_default_values"
    :component-name="nazwa_komponentu"
  >
    <div class="h-15" />
  </CmsCustomComponent>
</template>
